import {
  BarChart3, PieChart as PieIcon, LineChart as LineIcon,
  TrendingUp, Users, Building2, Grid3X3, AlertCircle, ListChecks,
} from 'lucide-react';

// Catalogue des widgets BI disponibles (type, libellé, icône, largeur de colonne, description).
export const WIDGET_CATALOG = [
  { type: 'kpis', label: 'KPIs synthétiques', icon: TrendingUp, w: 12,
    description: 'Total dossiers, économies, taux éligibilité, économie moyenne' },
  { type: 'dossiers_par_mois', label: 'Dossiers par mois (par taxe)', icon: BarChart3, w: 6,
    description: 'Histogramme cumulé TICFE / TICGN / TURPE sur 12 mois' },
  { type: 'economies_par_type', label: 'Économies par type', icon: PieIcon, w: 6,
    description: 'Camembert TICFE vs TICGN vs TURPE' },
  { type: 'economies_par_agence', label: 'Économies par agence', icon: Building2, w: 6,
    description: 'Camembert : qui performe le plus (cliquable)' },
  { type: 'economies_par_commercial', label: 'Économies par commercial', icon: Users, w: 6,
    description: 'Top performers (camembert cliquable)' },
  { type: 'evolution_economies', label: 'Évolution mensuelle des économies', icon: LineIcon, w: 12,
    description: 'Courbe sur 12 mois' },
  { type: 'heatmap_commerciaux_mois', label: 'Heatmap Commerciaux × Mois', icon: Grid3X3, w: 12,
    description: 'Matrice activité par commercial et mois (cliquable)' },
  { type: 'dossiers_a_cloturer', label: 'Dossiers à clôturer (CERFA < 6 mois)', icon: AlertCircle, w: 12,
    description: 'Liste des dossiers urgents' },
  { type: 'liste_dossiers', label: 'Liste des dossiers', icon: ListChecks, w: 12,
    description: 'Dossiers filtrés, cliquables pour ouvrir le rapport dans un nouvel onglet' },
];

export const PIE_COLORS = ['#397DFF', '#F97316', '#0891B2', '#7C3AED', '#10B981', '#EC4899', '#F59E0B', '#6366F1', '#14B8A6', '#EF4444'];

export const EMPTY_FILTERS = { date_debut: '', date_fin: '', agence_id: '', commercial_id: '', eligibilite: '', valide_client: '', taxe: '' };

export const TAXE_BADGE = { TICFE: 'bg-blue-50 text-blue-700', TICGN: 'bg-orange-50 text-orange-700', TURPE: 'bg-cyan-50 text-cyan-700' };
